module.exports = __webpack_public_path__ + "img/DSC_1891.ae43b686.JPG";